import { createContext } from 'react';
import { getDefaultCardConfig } from '../../lib/events';

export const CardConfigContext = createContext(getDefaultCardConfig());
